import React from 'react'
import './../../styles/TradeCryptocurrenciesStyles/tradecrypto.css'
import {connect} from 'react-redux'
import RoboticHand from './RoboticHand.js'
import Time from './../../resources/TradeCryptoResources/clock.svg'
import Discount from './../../resources/TradeCryptoResources/discount.svg'
import Shield from './../../resources/TradeCryptoResources/shield.svg'

import Background from './../../resources/TradeCryptoResources/background.svg'

class TradeCrypto extends React.Component{
    render(){
        return(
            <section className="trc__container-outer" id='exchange-to-fiat-anchor'>
                <div className="trc__robotic-hand">
                    <RoboticHand/>
                </div>
                <div className="trc__container">
                    <div className="trc__text-box">

                        {(this.props.windowDimensions.windowWidth > 400) ?
                            <div className="trc__3-box">
                                <div className="trc__time-box" style={{marginRight: '25px'}}>
                                    <img className="trc__3-img" src={Time} />
                                    <div style={{marginTop: '5px'}}>
                                        Domestic<br/>transfer
                                    </div>
                                </div>
                                <div className="trc__time-box" style={{marginRight: '25px'}}>
                                    <img className="trc__3-img" src={Discount} />
                                    <div style={{marginTop: '5px'}}>
                                        No added<br/>fees
                                    </div>
                                </div>
                                <div className="trc__time-box" style={{marginRight: '25px'}}>
                                    <img className="trc__3-img" src={Shield} />
                                    <div style={{marginTop: '5px'}}>
                                        Safe
                                    </div>
                                </div>
                            </div>
                            :
                            <div className="trc__3-box">
                                <div className="trc__time-box" style={{marginRight: '25px'}}>
                                    <img className="trc__3-img" src={Time} />
                                    <div style={{marginTop: '5px'}}>
                                        Domestic<br/>transfer
                                    </div>
                                </div>
                                <div className="trc__time-box" style={{marginRight: '25px'}}>
                                    <img className="trc__3-img" src={Discount} />
                                    <div style={{marginTop: '5px'}}>
                                        No added<br/>fees
                                    </div>
                                </div>
                                <div className="trc__time-box" style={{marginRight: '25px'}}>
                                    <img className="trc__3-img" src={Shield} />
                                    <div style={{marginTop: '5px'}}>
                                        Safe
                                    </div>
                                </div>
                            </div>
                        }
                        <h1 className="trc__title title">
                            Trade cryptocurrencies and quickly convert to USD, GBP, EUR and more
                        </h1>
                        <div className="text">
                            The Kronn exchange allows for crypto to crypto trading through order books and crypto to fiat currency exchange at real-time market value rates.
                            <br/><br/>
                            Fiat withdrawalis done via domestic transfers when possible ensuring low transfer costs and minimal transfer time. Our ICO funding will allow us to expand the exchange network to more countries, allowing for greater global reach.
                            <br/><br/>
                            Coin listings are chosen through community polls to encourage customer loyalty and add coins that will have higher transaction volumes.
                            <br/><br/>
                            On top of all this, transactions between Kronn Exchange accounts are feeless and instantaneous.
                        </div>
                        {/* {(this.props.windowDimensions.windowWidth > 400) ?
                            null
                            :
                            <div className="trc__3-box">
                                <div className="trc__time-box" style={{marginRight: '25px'}}>
                                    <img className="trc__3-img" src={Time} />
                                    <div style={{marginTop: '5px'}}>
                                        Nimble<br/>Exchange
                                    </div>
                                </div>
                                <div className="trc__time-box" style={{marginRight: '25px'}}>
                                    <img className="trc__3-img" src={Discount} />
                                    <div style={{marginTop: '5px'}}>
                                        Low<br/>Transaction Fees
                                    </div>
                                </div>
                                <div className="trc__time-box" style={{marginRight: '25px'}}>
                                    <img className="trc__3-img" src={Shield} />
                                    <div style={{marginTop: '5px'}}>
                                        Safe <br/> Exchange
                                    </div>
                                </div>
                            </div>
                        } */}
                    </div>


                    {/* <div className="trc__robotic-hand">
                        <RoboticHand/>
                    </div> */}
                </div>
            </section>
        )
    }
}


const mapStatesToProps = (state) =>{
    return{
        windowDimensions: state.windowDimensions,
    }
}


export default connect(mapStatesToProps)(TradeCrypto)



// WEBPACK FOOTER //
// ./src/components/TradeCrypto/TradeCrypto.js